import Vue from 'vue'
import ga from 'vue-ga'
import router from '../routes'

const isDevelopment = process.env.NODE_ENV === 'development'
const isProduction = process.env.NODE_ENV === 'production'

if (!isDevelopment) {
  ga(router, process.env.GOOGLE_UA)
}

Vue.prototype.$analytics = (...args) => {
  if (!isDevelopment) {
    window.ga(...args)
  }

  if (!isProduction) {
    console.log('Analytics Tracking', JSON.stringify(args))
  }
}

Vue.analytics = Vue.prototype.$analytics
